import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import axios from 'axios';

const root = ReactDOM.createRoot(document.getElementById('root'));

axios.interceptors.request.use(
  config => {
    const token=localStorage.getItem('auth-token');
    if(token==null){return config;}
    config.headers['Authorization'] = "Bearer "+token;
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
